<div class="mb-2">
    <app-company-filter (onChange)="filterChange($event)" [enableCategory]="true" context="company"></app-company-filter>
</div>
<app-table [columns]="columns" [data]="selectedSavings" [settings]="settings" [loading]="loading" [selectors]="selectors"
    (selectorChange)="onSelectorChange($event)">
    <ng-template #row let-item="item">
        <measure-details [measure]="item" [currency]="currency"></measure-details>
        <hr>
    </ng-template>
</app-table>